import React from "react";
import type { Descendant } from "slate";

import { useTextBlockRendering } from "./TextBlockRenderContext";
import { TextBlockRenderOptions } from "./types";

interface TextBlockProps {
  id: string;
  initialValue: Descendant[];
  options?: TextBlockRenderOptions;
}

export const TextBlock: React.FC<TextBlockProps> = ({ id, initialValue, options }) => {
  const { renderTextBlock } = useTextBlockRendering();
  return renderTextBlock(id, initialValue, options);
};
